import api from "./index";

export const getInfoFaqService = async () =>
  await api.get('faq/list/true');
